/*
 *     Copyright (c) 2020 Bcame S.r.l.. All rights reserved.
 *     Bcame S.r.l. Technology Business Unit
 *
 *     Company confidential.
 *
 *     This software is proprietary  to and embodies the confidential
 *     technology of Bcame S.r.l..  Possession, use, or copying of this
 *     software and media is authorized only pursuant to a valid written
 *     license from Bcame S.r.l.  or an authorized sublicensor.
 *
 *     Bcame S.r.l.
 */

<template>
  <div class="wrapp-page-login">
    <div class="block-content">
      <div class="block-content__body">
        <div class="image-background" v-lazy:background-image="backgroundImage"></div>
        <div class="wrapp-content">
          <div class="column-panel left-column">
            <div class="box-text">
              <div class="wrapp-icon">
                <svg class="o-icon"><use xlink:href="#logo-viewide"></use></svg>
              </div>
              <div class="wrapp-intro">
                <p>Benvenuti nell’app servizi di COIN</p>
              </div>
              <div class="wrapp-footer">
                <p>All Rights reserved. Bcame S.r.L {{currentYear}}</p>
              </div>
            </div>
          </div>
          <div class="column-panel right-column">
            <div class="box-login">
              <div class="wrapp-logo">
                <BrandLogo />
              </div>
              <div class="wrapp-subtitle">
                <p></p>
              </div>
              <div class="wrapp-form">
                <b-form @submit.stop.prevent="handleSubmit" data-vv-scope="form-login" class="form-login">
                  <div class="group-inputs">
                    <b-form-group id="groupEmail">
                      <base-input
                        name="email"
                        autocomplete="email"
                        v-validate="'required'"
                        v-model="email"
                        type="text"
                        classInput="rounded"
                        :placeholder="'*' + $t('Email')"
                        :validations="[
                          {
                            condition: errors.has('form-login.email')
                          }
                        ]"
                      >
                      </base-input>
                    </b-form-group>
                    <b-form-group id="groupPassword">
                      <base-input
                        autocomplete="current-password"
                        name="password"
                        v-validate="'required'"
                        v-model="password"
                        classInput="rounded"
                        type="password"
                        :placeholder="'*' + $t('Password')"
                        :validations="[
                          {
                            condition: errors.has('form-login.password')
                          }
                        ]"
                      >
                      </base-input>
                    </b-form-group>
                  </div>
                  <div class="wrapp-submit login-cta">
                    <div class="form-errors is-invalid" v-show="serverValidation">
                      <p v-html="serverValidation"></p>
                    </div>
                    <button class="btn btn-icon btn-icon-border-black btn-rounded btn-icon-large" type="submit">
                      <svg class="o-icon"><use xlink:href="#long-arrow-right"></use></svg>
                    </button>
                  </div>
                </b-form>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { EventBus } from '@/helpers'
import { changeStore } from 'theme/helpers'
import Logger from '@/services/Logger'
import BrandLogo from 'theme/components/BrandLogo/BrandLogo'
import BaseInput from 'theme/components/Form/BaseInput'

export default {
  name: 'LoginPage',
  inject: ['$validator'],
  data () {
    return {
      email: '',
      password: '',
      serverValidation: '',
      backgroundImage: require('theme/assets/image/login-bg.jpg'),
      currentYear: new Date().getFullYear()
    }
  },
  methods: {
    accountPage (params) {
      this.serverValidation = ''
      if (this.afterLogin) {
        this.afterLogin(params)
      } else {
        this.$router.push({ name: 'home' })
      }
    },
    clearForm () {
      this.username = this.password = ''
      this.$validator.reset()
      document.querySelector('input[name="email"]').focus()
    },
    handleSubmit (evt) {
      const self = this
      if (evt) {
        evt.preventDefault()
      }
      this.serverValidation = ''
      this.$validator.validateAll('form-login').then(isValid => {
        if (isValid) {
          self.$store.commit('ui/showLoader')
          self.$store.dispatch('userAdmin/login', { username: self.email, password: self.password })
            .then(boutique => {
              self.clearForm()
              self.$refs.modal && self.$refs.modal.hide()
              return changeStore({ vm: self, store: self.$store, router: self.$router, boutique, isOnlineStore: false })
                .then((res) => {
                  self.$store.commit('ui/hideLoader', false)
                  self.openMenu()
                })
            })
            .catch((error) => {
              Logger.error(error)
              const { response } = error
              const msg = response && response.data && response.data.message ? response.data.message : 'GenericError'
              self.$store.commit('ui/hideLoader', false)
              self.serverValidation = self.$t(msg)
            })
        }
      })
    },
    openMenu () {
      let componentToLoad = import('theme/components/Menu/HamburgerMenu')
      return this.$store.dispatch('ui/loadLeftActiveComponent', { component: componentToLoad })
    }
  },
  mounted () {
    EventBus.$on('userAdmin:isLoggedIn', () => {
      this.accountPage({ provider: 'standard' })
    })
  },
  destroyed () {
    EventBus.$off('userAdmin:isLoggedIn', this.accountPage)
  },
  components: {
    BrandLogo,
    BaseInput
  }
}
</script>
